import * as React from 'react';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Body} from 'shells/typography/body';

export function UnlicensedUserBanner() {
    return (
        <FlashBanner hasBorder={true} type='info'>
            <div className='flex align-center full-width'>
                <Body color='blue'>
                    This user will not have access to Nutshell, they do not have any licenses.
                </Body>
            </div>
        </FlashBanner>
    );
}
